import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Button } from 'shards-react'

import '../../invite-accept-screen.css'

export default function ActiveMiniAppMessage({ miniAppInformations, goToLoginPage }) {
    ActiveMiniAppMessage.propTypes = {
        miniAppInformations: PropTypes.object,
        goToLoginPage: PropTypes.func,
    }

    return (
        <Fragment>
            <i
                className="material-icons invite-accept--icon--warning"
                style={{
                    fontSize: 75,
                }}
            >
                error
            </i>
            <p>Olá, convidado.</p>
            <p>A solicitação para trabalhar no projeto</p>
            <p>
                <span className="invite-accept--mini-app-text--bold">{` ${miniAppInformations.miniAppName} `}</span>
            </p>
            <p>já foi aceita anteriormente.</p>
            <Button id="invite-accept--back-button" onClick={goToLoginPage}>
                Acessar o portal
            </Button>
        </Fragment>
    )
}
